import { validateContactNumber, validateDate, validateEmail, validateNumber, validateSingleSelection, validateTime } from '@om/validation';
import {
    validateAlphaNumericString,
    validateAlphaNumericStringAllowingOnlyNumbers,
    validateAlphaNumericStringLenient,
    validateFullName,
    validateName,
    validateGenericString,
    validateNumericString
} from '@om/validation/src/validators/string-validator';
import { setAhocIncidentDetailsFieldValid } from '../../../actions/allsureHomeClaim/incidentDetails';
import { getBasicDetailsForm } from '../../../selectors/allsureHomeClaim/basicDetails';
import { RADIO_OPTION } from '../../../actions/allsureHomeClaim/types';
import { getIncidentDetailsForm } from '../../../selectors/allsureHomeClaim/incidentDetails';
import { validateDateBW } from '@om/validation/src/validators/date-validator';
import { calculateAge } from '../../../functions/easiplusFuneralPlan/Util';
import { validateEmailAddress } from '@om/validation/src/validators/email-validator';

let prevValidationAction = null;

export const incidentDetailsValidations = (store, next, action) => {
    const state=store.getState()
    const {damageOccuredPreviously,thirdPartyReponsilbile,personTobeKeptInformed, dateOfIncident}=getIncidentDetailsForm(state)
    const getTommorowsDate = () => {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate());
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const getLessThanThreeYears = () => {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate());
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1;
        const year = (currentDate.getFullYear() - 3);
        return `${day}/${month}/${year}`;
    };

    const todayDate = (dateOfIncident?.value && dateOfIncident?.value) 

    const calculateDaysFromDate = (incidentDate) => {
        const [day, month, year] = incidentDate.split('/').map(Number);
        const incident = new Date(year, month - 1, day);
        const currentDate = new Date();
        const timeDiff = currentDate - incident;
        const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        return days;
    }
    const validateDateFormat=(value)=>{
        if(!value){
            return null
        }
    else  return value.length===10 ? null : "Oops, you need to enter a valid date in the dd/mm/yyyy format"
    }
    const removeWhiteSpacesFromValue = (value) => (value ? value.replace(/ /g, '') : value);
    const validationAction = (() => {
        let error;
        const trimValue = (value) => (value ? value.trim() : value);
        switch (action.value.fieldType) {
            case 'dateOfIncident':
                error = validateDateFormat(action.value.value) ?? validateDateBW(action.value.value, {
                    min: getLessThanThreeYears(),
                    max: getTommorowsDate(),
                    subject: 'date of incident',
                    required: true,
                });
                break;
            case 'reasonForDelay': 
                error = validateAlphaNumericStringLenient(action.value.value, {
                    min: 25,
                    max: 2500,
                    required: true,
                    subject: 'reason for late notification',
                });
            break;
            case 'timeOfIncident':
                error = validateTime(action.value.value, {
                    date: todayDate,
                    subject: 'time of incident',
                    required: true,
                });
                break;
            case 'addressOrLocation':
                error = validateAlphaNumericStringLenient(action.value.value, {
                    min: 10,
                    max: 255,
                    required: true,
                    subject: 'address or location of the incident',
                });
                break;
            case 'insuredValue':
                error = validateNumber(action.value.value, {
                    required: true,
                    subject: 'value of property (in P)',
                });
                break;
            case 'dateValued':
                error = validateDateFormat(action.value.value) ?? validateDate(action.value.value, {
                    max: getTommorowsDate(),
                    required: false,
                    subject: 'date valued',
                });
                break;
            case 'lossOccurredDescription':
                error = validateAlphaNumericStringLenient(action.value.value, {
                    min: 50,
                    max: 2500,
                    required: true,
                    subject: 'description of loss occurred',
                });
                break;
            case 'categoryType':
                error = validateSingleSelection(action.value.value, 'Claim type');
                break;
            case 'occupiedAtTimeOfLoss':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            case 'burglarAlarmActivated':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            case 'damageOccuredPreviously':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            case 'damageOccuredPreviouslyDescription':
                error = validateAlphaNumericStringLenient(action.value.value, {
                    min: 50,
                    max: 2500,
                    required: true,
                    subject: 'description of previous damage occurred',
                });
                break;
            case 'insurerName':
                error = validateAlphaNumericStringLenient(action.value.value, {
                    min: 3,
                    max: 66,
                    required: true,
                    subject: 'insurer name',
                });
                break;
            case 'thirdPartyReponsilbile':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            case 'personTobeKeptInformed':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            case 'thirdPartyName':
                error = validateAlphaNumericStringLenient(action.value.value, {
                    min: 3,
                    max: 66,
                    required: false,
                    subject: 'third party name',
                });
                break;
            case 'thirdPartyContactNumber':
                error = validateNumericString(removeWhiteSpacesFromValue(action.value.value), {
                    min:5,
                    max:16,
                    required:false,
                    subject: 'third party cellphone number',
                });
                break;
            case 'thirdPartyAddress':
                error = validateAlphaNumericStringLenient(action.value.value, {
                    min: 10,
                    max: 255,
                    required: false,
                    subject: 'third party address',
                });
                break;
            case 'thirdPartyEmail':
                error = validateEmailAddress(trimValue(action.value.value), {
                    min: 7,
                    max: 60,
                    subject: 'third party email address',
                    required: false,
                });
                break;
                    case 'personsFullName':
                        error = validateAlphaNumericStringLenient(action.value.value, {
                            min: 3,
                            max: 66,
                            required: true,
                            subject: 'contact person’s full name',
                        });
                        break;
                    case 'personsContact':
                        error = validateNumericString(removeWhiteSpacesFromValue(action.value.value), {
                            min:5,
                            max:16,
                            required:true,
                            subject: 'contact person’s cellphone number',
                        });
                        break;
                    case 'personsEmail':
                            error = validateEmailAddress(trimValue(action.value.value), {
                                min: 7,
                                max: 60,
                                subject: 'contact person’s email address',
                                required: false,
                            });
                            break;
            default:
                return null;
        }

        return setAhocIncidentDetailsFieldValid(error, action.value.fieldType);
    })();

    if (!validationAction) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
